import graphql__cee0df38b861f863f2b5 from "./__generated__/ContributionsDataviz_visualization.graphql.js";import { createContext, useContext, useState } from "react";
import { graphql, useFragment } from "react-relay";
import { useSelector } from "react-redux";
import { useParams, Navigate, Outlet } from "react-router";

import { useRoutesContext } from "../../../Routes/RoutesContext";
import { unlocalizePathname } from "../../../Utils/localizedLocation";

const ContributionsDatavizContext = createContext({});

export const useContributionsDatavizContext = () =>
  useContext(ContributionsDatavizContext);

const ContributionsDataviz = props => {
  const { contributionsPerPage, enableListViewOnFirstPage } = useFragment(
    ContributionsDataviz_visualization,
    props.visualization
  );

  const firstPageVisualizationType = enableListViewOnFirstPage
    ? "datavizList"
    : "datavizGraph";

  const location =
    useSelector(({ location }) => location.currentLocation) || window.location;
  const { pathFor } = useRoutesContext();

  const [container, setContainer] = useState();

  const { participativeModuleSlug } = useParams();
  const moduleRootPath = pathFor("participativeModule", { participativeModuleSlug });

  // The `pathFor` returns unlocalized paths as we only use unlocalized paths for
  // navigation, and react-router adds the `/locale` basename prefix.
  const currentPath = unlocalizePathname(location.pathname?.replace(/\/$/, ""));

  // If the user is on the participative module root page, redirect it to the graph path,
  // to allow the routing system to be aware that we're inside the dataviz routes group,
  // and handle pages changing without resetting the scroll position to the top of the
  // page, which feels bad inside the dataviz. Note that we navigate with replace={true}
  // to ensure that the browser history only includes the graph path and let the user use
  // the back button of his brower.
  if (currentPath === moduleRootPath) {
    const datavizPath = pathFor(firstPageVisualizationType, { participativeModuleSlug });
    return <Navigate to={datavizPath} replace={true} />;
  }

  // Outlet context for direct child routes (React Router v6+ pattern)
  // Context API for deeply nested components. Routes use useOutletContext() for better
  // scoping and clarity
  return (
    <ContributionsDatavizContext.Provider
      value={{ contributionsPerPage: contributionsPerPage }}
    >
      <div className="container participative-module-container participative-datavisualization">
        <div className="contributions-list position-relative" ref={setContainer}>
          {container && <Outlet context={{ contributionsPerPage }} />}
        </div>
      </div>
    </ContributionsDatavizContext.Provider>
  );
};

const ContributionsDataviz_visualization = graphql__cee0df38b861f863f2b5;

export default ContributionsDataviz;
